// extracted by mini-css-extract-plugin
module.exports = {"innerMargin":"OwnerInfo_innerMargin__3MgTt"};